/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UnsavedChangesState, UnsavedChangesType } from "~/features/unsavedChanges/types";

const initialState: UnsavedChangesState = {
  isDirty: false,
  showModal: false,
  type: UnsavedChangesType.MY_DETAILS,
  navigateLink: "",
};

const unsavedChangesSlice = createSlice({
  name: "unsavedChanges",
  initialState,
  reducers: {
    setShowModal: (state, action: PayloadAction<string>) => {
      state.showModal = true;
      state.navigateLink = action.payload;
    },
    setIsDirty: (state, action: PayloadAction<UnsavedChangesType>) => {
      state.isDirty = true;
      state.type = action.payload;
    },
    closeModal: (state) => {
      state.showModal = false;
      state.navigateLink = "";
    },
    clearState: (state) => {
      state.isDirty = false;
      state.showModal = false;
      state.navigateLink = "";
    },
  },
});

export const UnsavedChangesActions = unsavedChangesSlice.actions;

export const unsavedChangesReducer = unsavedChangesSlice.reducer;
